import connection from '../utils/api';

export const sendMassEmail = payload =>
  connection.post(`mail/send-email`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
